export default __webpack_public_path__ + "f1723813fdefe3499998ae24724b6d9d.svg";